import WeatherApp from './components/WeatherApp'
import './components/WeatherApp.css'

const App = () => {
  return (
    <div>
      <WeatherApp />
    </div>
  )
}

export default App
